import { SvgIconProps, Theme, Tooltip, TooltipProps, useMediaQuery } from "@mui/material";
import { MdsInfoXs } from "@sinch/icons";
import React, { FC, ReactNode } from "react";
import { MdsIcon } from "../../MdsIcon/MdsIcon";

export interface InfoTooltipProps extends Omit<SvgIconProps, "icon" | "ref"> {
  /**
   * Title of tooltip
   */
  title?: ReactNode;
  placement?: TooltipProps["placement"];
}

/**
 * Info icon with tooltip message
 */
export const InfoTooltip: FC<InfoTooltipProps> = ({ title, sx, placement, ...props }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  return (
    <Tooltip arrow enterTouchDelay={0} placement={placement ?? (isMobile ? "top" : "right")} title={title}>
      <MdsIcon fontSize="xs" icon={MdsInfoXs} {...props} sx={{ color: ({ palette }) => palette.grey[500], ...sx }} />
    </Tooltip>
  );
};
